import { modifier } from 'ember-modifier';

export default modifier((element, [isFocused]) => {
  let currentValue = element.innerText.trim() || element.value.trim();
  if (isFocused) {
    if (currentValue !== '') {
      element.select();
    }
    setTimeout(function () {
      element.focus();
    }, 0);
  }
});
